import React  from "react";
import { useParams } from 'react-router-dom';
import Card from "components/card";
import StartReviewForm from "./components/StartReviewForm";

const ViewPerformanceReview = () => {
	const { reviewId } = useParams();

	return (
		<div className="mt-5 grid h-full grid-cols-1 gap-4">
			<StartReviewForm recordId={reviewId} mode="view"/>
		</div>
	);
};

export default ViewPerformanceReview;